import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IAlisFatura_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IAlisFatura_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  GetInvoicePurchase: any[];
  GetInvoicePurchase_dummy: any[];
  GetVendorAccounts: any[];
  GetVendorAccounts_dummy: any[];
  InvoicePurchaseHeader: any[];
  InvoicePurchaseHeader_dummy: any[];
  GetInvoicePurchaseVendorChar: any[];
  GetInvoicePurchaseVendorChar_dummy: any[];
  GetInvoicePurchaseVendorCharTotal: any[];
  GetInvoicePurchaseVendorCharTotal_dummy: any[];
  GetInvoicePurchaseBrandChar: any[];
  GetInvoicePurchaseBrandChar_dummy: any[];
  GetImage: any[];
  GetImage_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  isComp939690Visible: "visible" | "hidden";
  isComp346579Visible: "visible" | "hidden";
}

export class AlisFatura_ScreenBase extends React.PureComponent<
  IAlisFatura_ScreenProps,
  any
> {
  alisfatura_411475_value_kuikaSelectBoxRef: React.RefObject<any>;
  alisfatura_760966_value_kuikaAutoCompleteRef: React.RefObject<any>;
  alisfatura_537989_value_kuikaSelectBoxRef: React.RefObject<any>;
  alisfatura_303536_value_kuikaSelectBoxRef: React.RefObject<any>;
  alisfatura_209759_value_kuikaSelectBoxRef: React.RefObject<any>;
  alisfatura_888430_value_kuikaTableRef: React.RefObject<any>;
  alisfatura_68619_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "1a6c0151-a4ef-4dd3-8f65-4e2245a3fada",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 252560, PropertyName: "label", Value: "Profil" },
        { Id: 442506, PropertyName: "label", Value: "Çıkış Yap" },
        { Id: 809667, PropertyName: "value", Value: "Alış Faturaları" },
        { Id: 411475, PropertyName: "placeholder", Value: "Zaman Aralığı" },
        { Id: 760966, PropertyName: "placeholder", Value: "Tedarikçi" },
        { Id: 927759, PropertyName: "value", Value: "Detaylı Filtrele" },
        { Id: 537989, PropertyName: "placeholder", Value: "Marka" },
        { Id: 303536, PropertyName: "placeholder", Value: "Kategori" },
        { Id: 209759, PropertyName: "placeholder", Value: "Ürün Grubu" },
        { Id: 621226, PropertyName: "value", Value: "Verilen Sipariş" },
        { Id: 887540, PropertyName: "value", Value: "adet" },
        { Id: 93650, PropertyName: "value", Value: "Gelen Sipariş" },
        { Id: 275592, PropertyName: "value", Value: "adet" },
        { Id: 485715, PropertyName: "value", Value: "Kalan Sipariş" },
        { Id: 358902, PropertyName: "value", Value: "adet" },
        { Id: 259650, PropertyName: "value", Value: "Toplam Satın Alımlar" },
        { Id: 680350, PropertyName: "value", Value: "Satın Alım Dökümü" },
        { Id: 646579, PropertyName: "value", Value: "Satın Alım Miktar" },
        { Id: 166318, PropertyName: "value", Value: "Satın Alım Toplam Tutar" },
        {
          Id: 550616,
          PropertyName: "value",
          Value: "Marka Bazında Satın Alımlar",
        },
        { Id: 56337, PropertyName: "value", Value: "Marka Seç" },
        {
          Id: 888430,
          PropertyName: "nodatafoundmessage",
          Value: "Veri Bulunamadı",
        },
        { Id: 328486, PropertyName: "title", Value: "Title" },
        { Id: 129259, PropertyName: "value", Value: "Fatura No" },
        {
          Id: 77338,
          PropertyName: "value",
          Value: "[datafield:invoicenumber]",
        },
        { Id: 450540, PropertyName: "value", Value: "Tedarikçi Adı" },
        {
          Id: 936610,
          PropertyName: "value",
          Value: "[datafield:vendordescription]",
        },
        { Id: 375257, PropertyName: "value", Value: "Tedarikçi Kodu" },
        { Id: 315184, PropertyName: "value", Value: "[datafield:vendorcode]" },
        { Id: 320295, PropertyName: "value", Value: "Miktar" },
        { Id: 390013, PropertyName: "value", Value: "[datafield:qty1]" },
        { Id: 484923, PropertyName: "value", Value: "Tutar" },
        {
          Id: 176436,
          PropertyName: "value",
          Value: "[datafield:loc_netamount]",
        },
        { Id: 277999, PropertyName: "value", Value: "Tarih" },
        { Id: 445407, PropertyName: "value", Value: "[datafield:invoicedate]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.alisfatura_411475_value_kuikaSelectBoxRef = React.createRef();
    this.alisfatura_760966_value_kuikaAutoCompleteRef = React.createRef();
    this.alisfatura_537989_value_kuikaSelectBoxRef = React.createRef();
    this.alisfatura_303536_value_kuikaSelectBoxRef = React.createRef();
    this.alisfatura_209759_value_kuikaSelectBoxRef = React.createRef();
    this.alisfatura_888430_value_kuikaTableRef = React.createRef();
    this.alisfatura_68619_value_kuikaPaginationRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      Logout: false,
      goToSignInActivity: "",
      GetInvoicePurchase: [],
      GetVendorAccounts: [],
      InvoicePurchaseHeader: [],
      GetInvoicePurchaseVendorChar: [],
      GetInvoicePurchaseVendorCharTotal: [],
      GetInvoicePurchaseBrandChar: [],
      GetImage: [],
      SetValueOf: "",
      dataSource_411475: [
        { key: "1", text: "Bugün" },
        { key: "2", text: "Son 7 Gün" },
        { key: "3", text: "Son 1 Ay" },
        { key: "4", text: "Son 3 Ay" },
        { key: "5", text: "Son  6 Ay" },
        { key: "6", text: "Son 1 Yıl" },
        { key: "7", text: "Tüm Tarihler" },
      ],
      dataSource_537989: [{ value: "Item 1" }, { value: "Item 2" }],
      dataSource_303536: [{ value: "Item 1" }, { value: "Item 2" }],
      dataSource_209759: [{ value: "Item 1" }, { value: "Item 2" }],
      isComp939690Visible: "hidden",
      isComp346579Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("alisfatura", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.AlisFaturaPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("alisfatura", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("alisfatura", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.AlisFaturaPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  AlisFaturaPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(3, "number"),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      customerCode_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      dateFilter_2: ReactSystemFunctions.convertToTypeByName(3, "number"),
      customerCode_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      dateFilter_3: ReactSystemFunctions.convertToTypeByName(3, "number"),
      customerCode_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      dateFilter_4: ReactSystemFunctions.convertToTypeByName(3, "number"),
      customerCode_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      dateFilter_5: ReactSystemFunctions.convertToTypeByName(3, "number"),
      Id_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AlisFatura/AlisFaturaPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoicePurchase = result?.data.getInvoicePurchase;

    stateVars.GetVendorAccounts = result?.data.getVendorAccounts;

    formVars.alisfatura_760966_value =
      stateVars.GetVendorAccounts !== undefined
        ? stateVars.GetVendorAccounts?.length > 0
          ? stateVars.GetVendorAccounts[0].currAccCode
          : null
        : this.state.GetVendorAccounts?.length > 0
        ? this.state.GetVendorAccounts[0].currAccCode
        : null;
    formVars.alisfatura_760966_options = stateVars.GetVendorAccounts;
    stateVars.InvoicePurchaseHeader = result?.data.invoicePurchaseHeader;
    formVars.alisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty1
        : null
    );
    formVars.alisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty1
        : null
    );
    formVars.alisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty1
        : null
    );
    stateVars.GetInvoicePurchaseVendorChar =
      result?.data.getInvoicePurchaseVendorChar;

    stateVars.GetInvoicePurchaseVendorCharTotal =
      result?.data.getInvoicePurchaseVendorCharTotal;
    formVars.alisfatura_759783_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].qty1
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].qty1
        : null
    );
    formVars.alisfatura_551714_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
        : null
    );
    stateVars.GetInvoicePurchaseBrandChar =
      result?.data.getInvoicePurchaseBrandChar;

    stateVars.GetImage = result?.data.getImage;
    formVars.alisfatura_23176_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AlisFaturaPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AlisFaturaPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.alisfatura_23176_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );

    formVars.alisfatura_760966_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetVendorAccounts !== undefined
        ? stateVars.GetVendorAccounts?.length > 0
          ? stateVars.GetVendorAccounts[0].currAccCode
          : null
        : this.state.GetVendorAccounts?.length > 0
        ? this.state.GetVendorAccounts[0].currAccCode
        : null
    );

    formVars.alisfatura_760966_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetVendorAccounts !== undefined
        ? stateVars.GetVendorAccounts?.length > 0
          ? stateVars.GetVendorAccounts[0].currAccCode
          : null
        : this.state.GetVendorAccounts?.length > 0
        ? this.state.GetVendorAccounts[0].currAccCode
        : null
    );

    stateVars.dataSource_760966 =
      stateVars.GetVendorAccounts ?? this.state.GetVendorAccounts;
    stateVars.dataSource_760966 =
      stateVars.GetVendorAccounts ?? this.state.GetVendorAccounts;
    formVars.alisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty1
        : null
    );

    formVars.alisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty1
        : null
    );

    formVars.alisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty1
        : null
    );

    stateVars.dataSource_932915 =
      stateVars.GetInvoicePurchaseVendorChar ??
      this.state.GetInvoicePurchaseVendorChar;
    formVars.alisfatura_759783_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].qty1
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].qty1
        : null
    );

    formVars.alisfatura_551714_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
        : null
    );

    stateVars.dataSource_638113 =
      stateVars.GetInvoicePurchaseBrandChar ??
      this.state.GetInvoicePurchaseBrandChar;

    stateVars.dataSource_888430 =
      stateVars.GetInvoicePurchase ?? this.state.GetInvoicePurchase;
    formVars.alisfatura_68619_total = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoicePurchase !== undefined
        ? stateVars.GetInvoicePurchase?.length > 0
          ? stateVars.GetInvoicePurchase[0].totalCount
          : null
        : this.state.GetInvoicePurchase?.length > 0
        ? this.state.GetInvoicePurchase[0].totalCount
        : null
    );
    formVars.alisfatura_68619_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoicePurchase !== undefined
        ? stateVars.GetInvoicePurchase?.length > 0
          ? stateVars.GetInvoicePurchase[0].pageCount
          : null
        : this.state.GetInvoicePurchase?.length > 0
        ? this.state.GetInvoicePurchase[0].pageCount
        : null
    );

    formVars.alisfatura_68619_total = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoicePurchase !== undefined
        ? stateVars.GetInvoicePurchase?.length > 0
          ? stateVars.GetInvoicePurchase[0].totalCount
          : null
        : this.state.GetInvoicePurchase?.length > 0
        ? this.state.GetInvoicePurchase[0].totalCount
        : null
    );
    formVars.alisfatura_68619_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoicePurchase !== undefined
        ? stateVars.GetInvoicePurchase?.length > 0
          ? stateVars.GetInvoicePurchase[0].pageCount
          : null
        : this.state.GetInvoicePurchase?.length > 0
        ? this.state.GetInvoicePurchase[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  AlisFaturaComponent_548561_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AlisFatura",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "655260",
      null,
      "left",
      "true",
      "100vw",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturaComponent_252560_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AlisFatura",
      "ProfileScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturaComponent_442506_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturaComponent_411475_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      customerCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      customerCode_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      customerCode_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      customerCode_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      pageNumber_4: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AlisFatura/AlisFaturaComponent_411475_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoicePurchaseVendorChar =
      result?.data.getInvoicePurchaseVendorChar;

    stateVars.GetInvoicePurchaseVendorCharTotal =
      result?.data.getInvoicePurchaseVendorCharTotal;
    formVars.alisfatura_759783_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].qty1
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].qty1
        : null
    );
    formVars.alisfatura_551714_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
        : null
    );
    stateVars.InvoicePurchaseHeader = result?.data.invoicePurchaseHeader;
    formVars.alisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty1
        : null
    );
    formVars.alisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty1
        : null
    );
    formVars.alisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty1
        : null
    );
    stateVars.GetInvoicePurchaseBrandChar =
      result?.data.getInvoicePurchaseBrandChar;

    stateVars.GetInvoicePurchase = result?.data.getInvoicePurchase;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AlisFaturaComponent_411475_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AlisFaturaComponent_411475_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "alisfatura_68619_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );
    formVars.alisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty1
        : null
    );

    formVars.alisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty1
        : null
    );

    formVars.alisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty1
        : null
    );

    stateVars.dataSource_932915 =
      stateVars.GetInvoicePurchaseVendorChar ??
      this.state.GetInvoicePurchaseVendorChar;
    formVars.alisfatura_759783_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].qty1
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].qty1
        : null
    );

    formVars.alisfatura_551714_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
        : null
    );

    stateVars.dataSource_638113 =
      stateVars.GetInvoicePurchaseBrandChar ??
      this.state.GetInvoicePurchaseBrandChar;

    stateVars.dataSource_888430 =
      stateVars.GetInvoicePurchase ?? this.state.GetInvoicePurchase;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturaComponent_760966_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      customerCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      customerCode_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      customerCode_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      customerCode_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      pageNumber_4: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AlisFatura/AlisFaturaComponent_760966_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.InvoicePurchaseHeader = result?.data.invoicePurchaseHeader;
    formVars.alisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty1
        : null
    );
    formVars.alisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty1
        : null
    );
    formVars.alisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty1
        : null
    );
    stateVars.GetInvoicePurchaseVendorChar =
      result?.data.getInvoicePurchaseVendorChar;

    stateVars.GetInvoicePurchaseVendorCharTotal =
      result?.data.getInvoicePurchaseVendorCharTotal;
    formVars.alisfatura_759783_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].qty1
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].qty1
        : null
    );
    formVars.alisfatura_551714_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
        : null
    );
    stateVars.GetInvoicePurchaseBrandChar =
      result?.data.getInvoicePurchaseBrandChar;

    stateVars.GetInvoicePurchase = result?.data.getInvoicePurchase;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AlisFaturaComponent_760966_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AlisFaturaComponent_760966_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "alisfatura_68619_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );
    formVars.alisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty1
        : null
    );

    formVars.alisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty1
        : null
    );

    formVars.alisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty1
        : null
    );

    stateVars.dataSource_932915 =
      stateVars.GetInvoicePurchaseVendorChar ??
      this.state.GetInvoicePurchaseVendorChar;
    formVars.alisfatura_759783_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].qty1
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].qty1
        : null
    );

    formVars.alisfatura_551714_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
        : null
    );

    stateVars.dataSource_638113 =
      stateVars.GetInvoicePurchaseBrandChar ??
      this.state.GetInvoicePurchaseBrandChar;

    stateVars.dataSource_888430 =
      stateVars.GetInvoicePurchase ?? this.state.GetInvoicePurchase;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturaComponent_451228_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "MarkaSecSatinAlma",
      "VendorName",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccDescription"
          )
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "MarkaSecSatinAlma",
      "VendorCode",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "MarkaSecSatinAlma",
      "dateFilter",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AlisFatura",
      "MarkaSecSatinAlma",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturaComponent_68619_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfatura_68619_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AlisFatura/AlisFaturaComponent_68619_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoicePurchase = result?.data.getInvoicePurchase;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AlisFaturaComponent_68619_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AlisFaturaComponent_68619_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_888430 =
      stateVars.GetInvoicePurchase ?? this.state.GetInvoicePurchase;
    formVars.alisfatura_68619_total = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoicePurchase !== undefined
        ? stateVars.GetInvoicePurchase?.length > 0
          ? stateVars.GetInvoicePurchase[0].totalCount
          : null
        : this.state.GetInvoicePurchase?.length > 0
        ? this.state.GetInvoicePurchase[0].totalCount
        : null
    );
    formVars.alisfatura_68619_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoicePurchase !== undefined
        ? stateVars.GetInvoicePurchase?.length > 0
          ? stateVars.GetInvoicePurchase[0].pageCount
          : null
        : this.state.GetInvoicePurchase?.length > 0
        ? this.state.GetInvoicePurchase[0].pageCount
        : null
    );

    formVars.alisfatura_68619_total = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoicePurchase !== undefined
        ? stateVars.GetInvoicePurchase?.length > 0
          ? stateVars.GetInvoicePurchase[0].totalCount
          : null
        : this.state.GetInvoicePurchase?.length > 0
        ? this.state.GetInvoicePurchase[0].totalCount
        : null
    );
    formVars.alisfatura_68619_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoicePurchase !== undefined
        ? stateVars.GetInvoicePurchase?.length > 0
          ? stateVars.GetInvoicePurchase[0].pageCount
          : null
        : this.state.GetInvoicePurchase?.length > 0
        ? this.state.GetInvoicePurchase[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [655260, ,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.AlisFaturaPageInit();
    }
  }
}
